// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader_tableHeader__2WP4q","tableHeaderRow":"TableHeader_tableHeaderRow__3HIDi","tableHeaderCell":"TableHeader_tableHeaderCell__WLBsM"};